import React, { useEffect, useRef, useState } from 'react'
import { Button, Dialog, Link, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, Typography } from '@mui/material'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import NewTokenDialog from './NewTokenDialog';
import { loginf } from '../../../store/usertoken/usertokenSlice'
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useAuthTokenMutation } from '../../../store/data/dataSlice';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: () => void;
};

const UserTokenDialog = ({open, onClose}: Props): JSX.Element => {
    const [tokenGenDialogOpen, setTokenGenDialogOpen] = useState(false);
    const [tfValue, setTfValue] = useState("");
    const dispatch = useAppDispatch();
    const loginStatus = useAppSelector(state => state.usertoken)
    const [validate] = useAuthTokenMutation();
    const [error, setError] = useState(false);
    const { t } = useTranslation();

    const onLogin = async () => {
        try {
            const result = await validate(tfValue).unwrap();
            if (result == true) {
                dispatch(loginf({token: tfValue}));
                window.location.reload();
            }
            else {
                setError(true);
            }
        }
        catch (error) {

        }
    };

    useEffect(() => {
        if(loginStatus.authenticated && loginStatus.token) {
            setTfValue(loginStatus.token);
        }
    }, []);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle><Trans>User Login</Trans></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {loginStatus.authenticated ? (
                        <DialogContentText>
                            <DialogContentText marginBottom={3}><Trans>Logged in as: </Trans><i>{loginStatus.token}</i></DialogContentText>
                            <DialogContentText><Trans>If you want to change the login token, please enter a different one and click "Login".</Trans></DialogContentText>
                        </DialogContentText>
                    ) : (
                        <DialogContentText>
                            <DialogContentText marginBottom={3}><Trans>Not logged in</Trans></DialogContentText>
                            <DialogContentText><Trans>You are currently not logged in. To login, please enter your usertoken and click on "Login".</Trans></DialogContentText>
                        </DialogContentText>
                    )}
                </DialogContentText>
                <TextField
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setTfValue(event.target.value);
                    }}
                    margin='normal'
                    id="name"
                    label={<Trans>Usertoken</Trans>}
                    type="token"
                    value={tfValue}
                    fullWidth
                    variant="outlined"
                />
                {error && <ErrorTypography message={"This token does not exist!"}/>}
                <Link href="#" onClick={()=>{setTokenGenDialogOpen(true)}}>
                    <Trans>I don't have a usertoken.</Trans>
                </Link>
            </DialogContent>
                {!loginStatus.authenticated ? (
                    <DialogActions>
                        <Button onClick={onClose}><Trans>Cancel</Trans></Button>
                        <Button onClick={onLogin}><Trans>Login</Trans></Button>
                    </DialogActions>
                ) : (                    
                    <DialogActions>
                        <Button onClick={onClose}><Trans>Close</Trans></Button>
                        <Button onClick={onLogin}><Trans>Login</Trans></Button>
                    </DialogActions>)}
            <NewTokenDialog open={tokenGenDialogOpen} onClose={()=>{setTokenGenDialogOpen(false)}}/>
        </Dialog>
    )
}

export default UserTokenDialog